/**
 * Events Page
 */

export default function HWY_Events() {
	const selectors = {
		location: ".upcoming-events .event-option",
		container: ".upcoming-events",
		loadMore: ".upcoming-events .load-more button",
	};

	const pageSize = 3;

	this.init = () => {

		jQuery(selectors.location).on("click", function () {
			const location = jQuery(this).data("target");
			const events = location != 'All' ? jQuery(this).closest(selectors.container).find(`.upcoming-event[data-location="${location}"]`) : jQuery(this).closest(selectors.container).find(`.upcoming-event`);

			jQuery(selectors.location).removeClass("active");
			jQuery(this).addClass("active");
			jQuery(this).closest(selectors.container).find(`.upcoming-event`).addClass("d-none");
			jQuery(selectors.loadMore).removeClass("d-none");

			events.each(function(index) {
				if (index < pageSize) {
					jQuery(this).removeClass("d-none")
				}
			})

			if ( events.length < pageSize ) {
				jQuery(selectors.loadMore).addClass("d-none");
			}
		});

		jQuery(selectors.loadMore).on("click", function () {
			const location = jQuery(selectors.location + ".active").data("target");
			const hiddenEvents = location == "All" ? jQuery(this).closest(selectors.container).find(`.upcoming-event.d-none`) : jQuery(this).closest(selectors.container).find(`.upcoming-event.d-none[data-location="${location}"]`);

			console.log(hiddenEvents.length);

			hiddenEvents.each(function(index) {
				if (index < pageSize) {
					jQuery(this).removeClass("d-none");
				}
			})

			if ( hiddenEvents.length < pageSize ) {
				jQuery(selectors.loadMore).addClass("d-none");
			}
		})
	};
}
